import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import AlertDismissible from "../../common/AlertDismissible";
import LoadingButton from "../../common/LoadingButton";
import NEW_VOLUNTEERS_MUTATION from "../queries/NEW_VOLUNTEERS_MUTATION";
import { AvailableRole } from "../types/AvailableRole";
import { NewMember } from "../types/NewMember";
import AddMemberItem from "./AddMemberItem";

const newRecord = {
  id: 0,
  full_name: "",
  email: "",
  phone: "",
  role: "Chapter Committee Member",
  roleStartDate: new Date(),
  roleEndDate: null,
};

const AddMembers = ({
  roles,
  chapterName,
}: {
  roles: AvailableRole[];
  chapterName: string;
}) => {
  const [validated, setValidated] = useState(false);
  const [pending, setPending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [newMembers, setNewMembers] = useState<NewMember[]>([{ ...newRecord }]);
  const add = () => {
    setNewMembers([
      ...newMembers,
      {
        ...newRecord,
        id: newMembers.length,
      },
    ]);
  };
  const changed = (member: NewMember) => {
    console.log(JSON.stringify(member));
    const changed = [...newMembers];
    changed[member.id] = { ...member };
    setNewMembers(changed);
  };

  const [addVolunteers, { loading: saving, error: addVolunteerError }] =
    useMutation(NEW_VOLUNTEERS_MUTATION, {
      variables: {
        volunteerData: [...newMembers],
        chapterId: chapterName,
      },
      onCompleted() {
        setPending(false);
        setNewMembers([]);
        setSuccess(true);
      },
    });
  useEffect(() => {
    if (pending && !saving) {
      addVolunteers();
      setPending(false);
    }
  }, [pending, saving, addVolunteers]);
  useEffect(() => {
    if (success) {
      setNewMembers([{ ...newRecord }]);
      setValidated(false);
    }
  }, [success]);
  const handleSubmit = (event: any) => {
    setSuccess(false);
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity()) {
      console.log(JSON.stringify(newMembers));
      setPending(true);
    }
    setValidated(true);
  };
  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Card>
        <Card.Body>
          <Card.Title>Request New Volunteers</Card.Title>
          {addVolunteerError && (
            <AlertDismissible variant="danger" className="my-3">
              There was a problem saving your requested new volunteers. Please
              try again.
            </AlertDismissible>
          )}
          {success && (
            <AlertDismissible variant="success" className="my-3">
              Your request to add new volunteers has been sent.
            </AlertDismissible>
          )}
          <Card.Text>
            The volunteers you add here will be reviewed and activated by DU
            Staff.
          </Card.Text>
          {newMembers?.map((m: NewMember, i: number) => (
            <AddMemberItem
              key={`new-volunteer-${i}`}
              roles={roles}
              add={add}
              setChanged={changed}
              isLast={newMembers.length === ++i}
              member={m}
            />
          ))}
          <LoadingButton loading={saving} variant="success" type="submit">
            Submit New Volunteer Request
          </LoadingButton>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default AddMembers;
